import { defineComponent as _defineComponent } from 'vue'
import CreateCollection from './CreateCollection.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Create',
  emits: ['navigateToCreateNftTab'],
  setup(__props, { emit }) {



const onCollectionCreated = () => {
  emit('navigateToCreateNftTab')
}

return { __sfc: true,emit, onCollectionCreated, CreateCollection }
}

})